import React from "react";

export const IconDisabledAccess = ({ handleClick = false }) => (
  <svg
    fill="none"
    viewBox="0 0 24 24"
    onClick={() => (handleClick ? handleClick() : null)}
  >
    <path
      d="m8 4c0.82843 0 1.5-0.67157 1.5-1.5s-0.67157-1.5-1.5-1.5-1.5 0.67157-1.5 1.5 0.67157 1.5 1.5 1.5z"
      fill="#000"
    />
    <path
      d="m8.5048 5.6095 1.3619 8.2762h4.9238l5.2381 7.0191m-10.895-11.419h5.6572m2.3047 7.3334c-0.1047 3.4571-3.0381 6.1809-6.4952 6.1809-3.6667 0-6.6-2.9333-6.6-6.6 0-3.1429 2.2-5.8667 5.2381-6.4952"
      stroke="#000"
      strokeMiterlimit="10"
      strokeWidth="1.5"
    />
  </svg>
);

export default IconDisabledAccess;
